import { __assign, __extends, __makeTemplateObject, __rest, __spreadArray } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { nanoid } from 'nanoid';
import { fontStack } from '../../utils/fontStack';
import { Separator } from '../../Separator';
var TabsComponent = /** @class */ (function (_super) {
    __extends(TabsComponent, _super);
    function TabsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeRef = React.createRef();
        _this.onKeyDown = function (event) {
            var _a = _this.props, active = _a.active, onChange = _a.onChange, children = _a.children;
            if (!onChange)
                return;
            var enabledTabs = [];
            React.Children.forEach(children, function (element, index) {
                if (React.isValidElement(element) && !element.props.isDisabled) {
                    var enabledTab = {
                        idx: index,
                        name: element.props.name,
                    };
                    enabledTabs.push(enabledTab);
                }
            });
            var activeIdx = enabledTabs.findIndex(function (_a) {
                var idx = _a.idx, name = _a.name;
                return idx === active || name === active;
            }) || 0;
            switch (event.key) {
                case 'Right':
                case 'ArrowRight': {
                    var nextEnabledTab = (activeIdx + 1) % enabledTabs.length;
                    var _b = enabledTabs[nextEnabledTab], idx = _b.idx, name_1 = _b.name;
                    onChange(name_1 || idx);
                    break;
                }
                case 'Left':
                case 'ArrowLeft': {
                    var length_1 = enabledTabs.length;
                    var nextEnabledTab = (activeIdx - 1 + length_1) % length_1;
                    var _c = enabledTabs[nextEnabledTab], idx = _c.idx, name_2 = _c.name;
                    onChange(name_2 || idx);
                    break;
                }
                default:
            }
        };
        return _this;
    }
    TabsComponent.prototype.componentDidUpdate = function (prevProps) {
        var active = this.props.active;
        if (prevProps.active !== active &&
            this.activeRef &&
            this.activeRef.current) {
            this.activeRef.current.focus();
        }
    };
    TabsComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, active = _a.active, onChange = _a.onChange, groupId = _a.groupId, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["active", "onChange", "groupId", "className", "children"]);
        var tabsArray = React.Children.map(children, function (child, index) {
            var element = child;
            if (React.isValidElement(element)) {
                var isActive = typeof active === 'number'
                    ? active === index
                    : active === element.props.name;
                var ident_1 = element.props.name ? element.props.name : index;
                element = React.cloneElement(element, {
                    onSelect: onChange && (function () { return onChange(ident_1); }),
                    ref: isActive ? _this.activeRef : undefined,
                    id: groupId + "-tab-" + ident_1,
                    'aria-controls': groupId + "-panel-" + ident_1,
                    isActive: isActive,
                });
            }
            return element;
        });
        var childrenArray = tabsArray === null || tabsArray === void 0 ? void 0 : tabsArray.reduce(function (acc, tabElelement, index, array) {
            var lastTabIndex = array.length - 1;
            var separatorElement = (React.createElement(Separator, { isVertical: true, className: "tab-separator", key: nanoid() }));
            if (index !== lastTabIndex) {
                return __spreadArray(__spreadArray([], acc), [tabElelement, separatorElement]);
            }
            return __spreadArray(__spreadArray([], acc), [tabElelement]);
        }, []);
        return (
        // Using roving tabIndex on Tab component instead
        // eslint-disable-next-line jsx-a11y/interactive-supports-focus
        React.createElement("div", __assign({}, htmlAttributes, { className: className, onKeyDown: this.onKeyDown, role: "tablist", "aria-orientation": "horizontal" }), childrenArray));
    };
    return TabsComponent;
}(React.Component));
export { TabsComponent };
export var Tabs = styled(TabsComponent)(function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    display: flex;\n\n    .tab-separator {\n      height: 2rem;\n      margin: 0;\n    }\n\n    .vertical-separator__container {\n      display: flex;\n      align-items: center;\n    }\n  "], ["\n    ", "\n    display: flex;\n\n    .tab-separator {\n      height: 2rem;\n      margin: 0;\n    }\n\n    .vertical-separator__container {\n      display: flex;\n      align-items: center;\n    }\n  "])), fontStack); });
Tabs.propTypes = {
    groupId: PropTypes.string,
    active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1;
//# sourceMappingURL=Tabs.js.map